<template>
	<AppLayout
		:title="boardWorkgroupMember.user.full_name"
		:subtitle="boardWorkgroupMember.area.name"
		:return-label="boardArea.name"
		:return-url="route('association.boards.areas.workgroup-members.index', {board: board.id, boardArea: boardArea.id})"
	>
		<template #actions>
			<PrimaryButton :color="Color.Red" @click.stop="store">
				<i class="fa-solid fa-ban mr-2"/>
				{{ trans('association.boards.areas.members.workgroup.expel.title') }}
			</PrimaryButton>
		</template>
		<Alert :color="Color.Amber">
			<div class="flex flex-col gap-2">
				<p v-for="warning in trans('association.boards.areas.members.workgroup.expel.warnings')">{{ warning }}</p>
			</div>
		</Alert>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {useForm} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Alert from '@/Components/UI/Alerts/Alert.vue'
import {type Board} from '@/Types/Association/Boards/Board'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type BoardArea} from '@/Types/Association/Boards/BoardArea'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {type BoardWorkgroupMember} from '@/Types/Association/Boards/BoardWorkgroupMember'

const props = defineProps<{
	board:Board,
	boardArea:BoardArea,
	boardWorkgroupMember:BoardWorkgroupMember,
}>()

const board:Ref<Board> = ref(props.board)
const working:Ref<boolean> = ref(false)
const boardArea:Ref<BoardArea> = ref(props.boardArea)
const boardWorkgroupMember:Ref<BoardWorkgroupMember> = ref(props.boardWorkgroupMember)

function store():void{
	if(!working.value){
		working.value = true
		showInfo(trans('association.boards.areas.members.workgroup.expel.processing'))
		useForm({}).post(route('association.boards.areas.workgroup-members.expel.store', {
			board: board.value.id,
			boardArea: boardArea.value.id,
			boardWorkgroupMember: boardWorkgroupMember.value.id,
		}), {
			onSuccess: () => {
				showSuccess(trans('association.boards.areas.members.workgroup.expel.processed'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>